import { createWallet } from "thirdweb/wallets";
const customStrategies = ["basement"];
export const allowedStrategies = [
    // Auth strategies
    "apple",
    "google",
    "github",
    "x",
    "discord",
    "email",
    "guest",
    // Wallet IDs
    "walletConnect",
    "io.metamask",
    "com.coinbase.wallet",
    // Custom strategies
    ...customStrategies,
];
export function isWalletType(strategy) {
    // Check if it's a known wallet ID pattern (com.*, io.*, etc.)
    const walletIdPattern = /^(com\.|io\.|app\.|xyz\.|me\.|org\.|pro\.)/;
    return strategy === "walletConnect" || walletIdPattern.test(strategy);
}
export function isStrategyType(strategy) {
    return !isWalletType(strategy);
}
export function getConnectOptionsFromStrategy(strategy) {
    if (!allowedStrategies.includes(strategy)) {
        throw new Error(`Invalid strategy: ${strategy}`);
    }
    if (strategy === "email") {
        throw new Error("Email strategy requires OTP flow and cannot be connected in a single step");
    }
    if (isWalletType(strategy)) {
        return { strategy: "wallet", wallet: createWallet(strategy) };
    }
    else {
        // @ts-expect-error we have custom strategies too
        return { strategy };
    }
}
export const strategyIcons = {
    google: "https://cdn.b3.fun/google.svg",
    github: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg",
    x: "https://cdn.b3.fun/x.svg?1",
    discord: "https://cdn.b3.fun/discord.svg",
    apple: "https://cdn.b3.fun/apple.svg",
    guest: "https://cdn.b3.fun/incognito.svg",
    microsoft: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
    slack: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Slack_icon_2019.svg",
};
export const strategyLabels = {
    google: "Google",
    x: "X",
    discord: "Discord",
    apple: "Apple",
    guest: "Guest",
    github: "GitHub",
    email: "Email",
    microsoft: "Microsoft",
    slack: "Slack",
};
// Test it
// console.log(getConnectOptionsFromStrategy("io.metamask"));
// console.log(getConnectOptionsFromStrategy("google"));
